import { useEffect, useRef } from 'react'

const useScrollElementIntoView = (selector: string, isEnabled = true, key = '') => {
  const refHasScrolledIntoView = useRef(false)
  const elRef = useRef<Element>()

  useEffect(() => {
    if (!isEnabled) {
      refHasScrolledIntoView.current = false
    }
  }, [isEnabled])

  useEffect(() => {
    refHasScrolledIntoView.current = false
  }, [key])

  useEffect(() => {
    const interval = setInterval(() => {
      elRef.current = document.body.querySelector(selector) ?? undefined

      const element = elRef.current

      if (!element || !isEnabled || refHasScrolledIntoView.current) {
        return
      }

      const { bottom, left, right, top } = element.getBoundingClientRect()

      const isVisible =
        top >= 0 &&
        left >= 0 &&
        right <= (window.innerWidth || document.documentElement.clientWidth) &&
        bottom <= (window.innerHeight || document.documentElement.clientHeight) + 30

      if (isVisible) {
        return
      }

      element.scrollIntoView({ behavior: 'smooth' })
      refHasScrolledIntoView.current = true
      clearInterval(interval)
    }, 300)

    return () => clearInterval(interval)
  }, [isEnabled, key])
}

export { useScrollElementIntoView }
